import type { AllRouteEndpoints } from "../routeTypes";

export const alloysPartnersGooglePostmasterAppGroupId = "/alloys/partners/google-postmaster/:app_group_id";

export const alloysPartnersGooglePostmasterAppGroupIdConnect =
  "/alloys/partners/google-postmaster/:app_group_id/connect";

export const deleteAlloysPartnersGooglePostmasterAppGroupIdCacheKeys: AllRouteEndpoints[] = [
  alloysPartnersGooglePostmasterAppGroupId,
];

export const postAlloysPartnersGooglePostmasterConnectCacheKeys: AllRouteEndpoints[] = [
  alloysPartnersGooglePostmasterAppGroupId,
];
